<template>
    <div id="pageTable">
        <v-container 
            class="d-flex align-center justify-center" 
            style="height: 80vh; width: 80vw;"
            v-if="rol != 'root' && rol != 'admin' && rol != 'admin-empresa' && rol != 'admin-sucursal' && rol!= 'admin-depto'"
        >
			<v-card class="" style="border-radius:20px" max-width="500">
                <v-card-title class="justify-center card_titulo">
                    <div class="headerModal">
                        <img :src="'/static/icon/peligro.svg'" class="imgModal"/>
                    </div>
                </v-card-title>
                <v-card-text class="titleModal text-center">
                    Esta vista no esta disponible para este rol de usuario.
                </v-card-text>
                <v-card-actions class="d-flex align-center justify-center card_accion">
                    <v-btn
                        class="btnGuardar"
                        @click="redireccionar()"
                    >
                        Ok
                    </v-btn>
                </v-card-actions>
            </v-card>
		</v-container>
        <v-container xl fluid v-else>
            <v-row>
                <v-col cols="12" lg="12" class="ml-2">
                    <data-table
                        ref="tableEmpleados"
                        :tableName="'Empleados inactivos'"
                        :url="url"
                        :columns="columns"
                        :filters="filters"
                        @setFilters="setFilters"
                        @loadModalData="loadModalData"
                        :perPage="[10, 25, 50, 100]"
                    >
                        <template slot="filters">
                            <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                                <template>
                                    <span class="RangoIngreso">Rango fecha de baja</span>
                                </template>
                            </v-col>

                            <v-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6" class="py-0">
                                <VuetifyDatePicker
                                    outlined
                                    v-model="fecha_inicio_c"
                                    label="Fecha inicio"
                                    placeholder="dd/mm/aaaa"
                                    ref="FechaInicioFilter"
                                />
                            </v-col>

                            <v-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6" class="py-0">
                                <VuetifyDatePicker
                                    outlined
                                    v-model="fecha_final_c"
                                    label="Fecha final"
                                    placeholder="dd/mm/aaaa"
                                    ref="FechaFinalFilter"
                                />
                            </v-col>

                            <template v-if="rol == 'root'">
                                <v-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6" class="py-0">
                                    <v-autocomplete
                                        outlined
                                        :items="clientes"
                                        item-text="nombre"
                                        item-value="id"
                                        label="Cliente"
                                        persistent-hint
                                        v-model="cliente_value"
                                    ></v-autocomplete>
                                </v-col>
                            </template>

                            <template v-if="rol == 'root' || rol == 'admin'">
                                <v-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6" class="py-0">
                                    <v-autocomplete
                                        outlined
                                        :items="empresas"
                                        item-text="nombre"
                                        item-value="id"
                                        label="Empresa"
                                        persistent-hint
                                        v-model="empresa_value"
                                    ></v-autocomplete>
                                </v-col>
                            </template>

                            <template v-if="rol == 'root' || rol == 'admin' || rol == 'admin-empresa'">
                                <v-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6" class="py-0">
                                    <v-autocomplete
                                        outlined
                                        :items="sucursales"
                                        item-text="nombre"
                                        item-value="id"
                                        label="Sucursal"
                                        persistent-hint
                                        v-model="sucursal_value"
                                    ></v-autocomplete>
                                </v-col>
                            </template>

                            <template
                                v-if="
                                    rol == 'root' ||
                                    rol == 'admin' ||
                                    rol == 'admin-empresa' ||
                                    rol == 'admin-sucursal'
                                "
                            >
                                <v-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6" class="py-0">
                                    <v-autocomplete
                                        outlined
                                        :items="departamentos"
                                        item-text="nombre"
                                        item-value="id"
                                        label="Departamento"
                                        persistent-hint
                                        v-model="empleado.departamento_id"
                                    ></v-autocomplete>
                                </v-col>
                            </template>
                        </template>

                        <tbody slot="body" slot-scope="{ data }">
                            <tr :key="item.id" v-for="item in data">
                                <td  style="min-width:159px!important; max-width:161px!important; width:160px;padding-right:4px;">
                                    <div>{{ item.clave }}</div>
                                </td>
                                <td @click="detalleEmpleado(item)">
                                    <div>
                                        <v-list color="transparent" class="py-0 my-0">
                                            <v-list-item two-line class="py-0 my-0 px-0">
                                                <v-list-item-avatar class="py-0 my-0">
                                                    <v-img  :src="urlImg+item.foto"></v-img>
                                                </v-list-item-avatar>
                                                <v-list-item-content class="ml-0 py-0 my-0">
                                                    <v-list-item-title class="tblPrincipal" style="white-space: normal !important;">{{ item.nombre_completo }}</v-list-item-title>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </v-list>
                                    </div>
                                </td>
                                <td>
                                    <div class="tblPrincipal">{{ dateFormat(item.fecha_ingreso) }}</div>
                                </td>
                                <td>
                                    <div class="tblPrincipal">{{ dateFormat(item.fecha_baja) }}</div>
                                </td>
                                <td>
                                    <div class="tblOpciones">
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on }">
                                                <v-btn
                                                    v-on="on"
                                                    slot="activator"
                                                    class="botonHover"
                                                    icon
                                                    fab
                                                    dark
                                                    @click="abrirModal(item)"
                                                    small
                                                >
                                                    <v-icon class="tamIconoBoton invertirColorBotones">remove_red_eye</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Motivo de baja</span>
                                        </v-tooltip>

                                        <template v-if="computedSistema">
                                            <v-tooltip bottom v-if="rol != 'admin-depto' && rol != 'empleado'">
                                                <template v-slot:activator="{ on }">
                                                    <v-btn
                                                        v-on="on"
                                                        slot="activator"
                                                        icon
                                                        fab
                                                        dark
                                                        class="botonHover"
                                                        @click="abrirModalRestaurar(item)"
                                                        small
                                                    >
                                                        <v-icon class="tamIconoBoton iconoDelgadoBoton">refresh</v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>Restaurar</span>
                                            </v-tooltip>
                                            <v-tooltip bottom v-if="rol != 'admin-depto' && rol != 'empleado'">
                                                <template v-slot:activator="{ on }">
                                                    <v-btn
                                                        v-on="on"
                                                        slot="activator"
                                                        class="botonHover"
                                                        icon
                                                        fab
                                                        dark
                                                        small
                                                        @click="eliminar(item.id, item.nombre, item.correo)"
                                                    >
                                                        <v-icon class="tamIconoBoton invertirColorBotonesDelete">delete</v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>Eliminar</span>
                                            </v-tooltip>
                                        </template>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </data-table>
                </v-col>
            </v-row>
        </v-container>
        <template>
            <v-dialog v-model="dialog" persistent max-width="1000px">
                <template v-slot:activator="{ on }">
                    <v-btn v-on="on" class="botonModal" id="btnModal"></v-btn>
                </template>
                <v-card>
                    <v-card-title class="justify-center card_titulo">
                        <div class="headerModal">
                            <img :src="imagen" class="imgModal" />
                            <h2 class="titleModal">{{ titulo_modal }}</h2>
                        </div>
                    </v-card-title>

                    <v-card-text class="px-0 pt-3">
                        <div id="loadingModal" v-show="!finaliza_carga">
                            <div id="loading">
                                <v-progress-circular
                                    indeterminate
                                    :size="100"
                                    :width="7"
                                    color="blue"
                                ></v-progress-circular>
                            </div>
                        </div>

                        <v-container v-show="finaliza_carga" grid-list-md>
                            <v-col xs="12" sm="12" md="12" class="pa-0 ma-0">
                                <data-table
                                    ref="tableHistorico"
                                    :url="url_historico"
                                    :columns="columns_historico"
                                    :filters="filters_historico"
                                    :showAdvancedFilters="false"
                                    :emptyTable="'emptyTableWhite'"
                                    :showPagination="true"
                                    :perPage="[5,10,15,20]"
                                    :classes="tableClasses"
                                    :idTabla="'tablaHistorico'"
                                    :modalTable="true"
                                >
                                    <tbody slot="body" slot-scope="{ data }">
                                        <tr :key="item.id" v-for="item in data">
                                            <td class="pr-1" style="background-color: #ffffff !important;">
                                                <div class="pl-0">{{ item.accion }}</div>
                                            </td>
                                            <td class="px-1" style="background-color: #ffffff !important;">
                                                <div class="">{{ item.nombre_tipo_baja }}</div>
                                            </td>
                                            <td class="px-1" style="background-color: #ffffff !important; width:150px">
                                                <div>{{ dateFormat(item.fecha) }}</div>
                                            </td>
                                            <td class="px-1" style="background-color: #ffffff !important;">
                                                <div>{{ item.descripcion }}</div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </data-table>
                            </v-col>
                        </v-container>
                    </v-card-text>
                    <v-card-actions class="d-flex justify-end card_accion">
                        <button
                                class="btnCerrar"
                                @click="cerrarModal()"
                                :disabled="loading_guardar"
                            >
                                Cerrar
                            </button>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </template>

        <template >
            <v-dialog v-model="dialog_restaurar" scrollable persistent max-width="600px" class="borde-card">
                <template v-slot:activator="{ on }">
                    <v-btn v-on="on" class="botonModal" id="btnModalRestaurar"></v-btn>
                </template>
                <v-card class="borde-card">
                    <perfect-scrollbar style="height:100%;">
                        <ValidationObserver ref="form" v-slot="{ invalid }">
                            <v-card-title class="justify-center card_titulo">
                                <div class="headerModal">
                                    <img :src="imagen" class="imgModal" />
                                    <h2 class="titleModal">{{ tituloModal }}</h2>
                                </div>
                            </v-card-title>

                            <v-card-text class="card_texto">
                                <v-col cols="12" xs="12" sm="12" md="12" class="pa-0 d-flex justify-center" v-if="isLoading">
                                    <v-progress-circular
                                        indeterminate
                                        :size="100"
                                        :width="7"
                                        color="blue"
                                    ></v-progress-circular>
                                </v-col>
                                <v-container v-if="!isLoading" grid-list-md id="contenedor">
                                    <v-divider class="divider"></v-divider>
                                    <v-row>
                                        <v-col cols="12" xs="12" sm="12" md="12" class="py-0" >
                                            <v-text-field
                                                outlined
                                                readonly
                                                v-model="dataEmpleado.nombre_completo"
                                                label="Nombre"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="12" xs="12" sm="12" md="12" class="py-0">
                                            <VuetifyDatePicker
                                                outlined
                                                rules="required"
                                                v-model="fechaRestaurar"
                                                label="Fecha"
                                                placeholder="dd/mm/aaaa"
                                                ref="FechaRestaurar"
                                            />
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-card-text>
                            <v-card-actions class="d-flex justify-end card_accion">
                                <button
                                    class="btnCerrar"
                                    @click="cerrarModal()" 
                                    :disabled="isSaving"
                                >
                                    Cancelar
                                </button>
                                <v-btn
                                    class="btnGuardar"
                                    @click="restaurarEmpleado()" 
                                    :disabled="invalid" 
                                    :loading="isSaving"
                                >
                                    Restaurar
                                </v-btn>
                            </v-card-actions>
                        </ValidationObserver>
                    </perfect-scrollbar>
                </v-card>
            </v-dialog>
        </template>
    </div>
</template>

<script>
import Vue from "vue";
import { mapState, mapActions } from "vuex";
import Notify from "@/plugins/notify";
import Swal from "sweetalert2";
import Datatable from "@/components/datatable/Datatable.vue";
import empleadosApi from "../api/empleados";
import catalogoApis from "../api/catalogos";
import clientesApi from "../api/clientes";
import empresaApi from "../api/empresas";
import sucursalApi from "../api/sucursales";
import departamentoApi from "../api/departamentos";
import horariosApi from "../api/horarios";
import PerfectScrollbar from "perfect-scrollbar";
import GetUrlImg from "@/plugins/Urlimagen";
import VuetifyDatePicker from '@/components/VuetifyDatePicker.vue';

export default {
    components: {
        VuetifyDatePicker,
        "data-table": Datatable,
    },
    data() {
        return {
            url: "empleados/find",
            columns: [
                {
                    label: "Clave",
                    name: "clave",
                    filterable: true,
                },
                {
                    label: "Nombre",
                    name: "nombre",
                    filterable: true,
                },
                {
                    label: "Fecha de ingreso",
                    name: "fecha_ingreso",
                    filterable: true,
                },
                {
                    label: "Fecha de baja",
                    name: "fecha_baja",
                    filterable: true,
                },
                {
                    label: "Opciones",
                    name: "opciones",
                    filterable: false,
                    align:'center'
                },
            ],

            filters: {
                activo          : false,
                baja            : true,
                cliente_id      : null,
                empresa_id      : null,
                sucursal_id     : null,
                departamento_id : null,
                paginate        : true,
                rol_name        : null,
                usuario_id      : null,
                order_by        : 'clave',
            },

            url_historico       : "historico_empleado/find",
            columns_historico: [
                {
                    label: "Tipo de movimiento",
                    name: "accion",
                    filterable: true,
                },
                {
                    label: "Tipo de baja IMSS",
                    name: "tipo_baja_imss_id",
                    filterable: true,
                },
                {
                    label: "Fecha",
                    name: "fecha",
                    filterable: true,
                },
                {
                    label: "Descripción",
                    name: "descripcion",
                    filterable: true,
                },
            ],
            tableClasses: {
                table: {
                    "no-box-shadow":true
                },
                "t-head": {
                    "no-radius": true,
                },
            },
            filters_historico: {
                empleado_id : null,
            },
            loading_guardar     : false,
            loading             : true,
            dialog              : false,
            dialogLayout        : false,
            dialogBusqueda      : false,
            search              : "",
            calendar            : false,
            ingreso             : false,
            baja                : false,
            complex: {
                selected: [],
                headers: [
                    /* { text:"Clave", value:"clave"}, */
                    { text: "Nombre Completo", value: "nombre_completo" },
                    { text: "Antigüedad", value: "dia_descanso" },
                    { text: "Ranking", value: "" },
                    /* { text:"Correo", value:"correo" }, */
                    { text: "Opciones", value: "" },
                ],
                items: [],
                urlImg: "",
            },
            empleado: {
                id              : 0,
                nombre          : null,
                apellido_paterno: null,
                apellido_materno: null,
                fecha_nacimiento: null,
                sexo            : null,
                direccion       : null,
                estado_id       : null,
                codigo_postal   : null,
                telefono        : "",
                correo          : null,
                estado_civil_id : null,
                fecha_ingreso   : null,
                fecha_baja      : null,
                dia_descanso    : "0",
                cliente_id      : null,
                empresa_id      : null,
                sucursal_id     : null,
                departamento_id : null,
                horario_id      : null,
                tiene_hijos     : false,
                puesto          : null,
                clave_interna   : null,
                email_anterior  : null,
                archivo         : null,
            },
            accion              : "",
            titulo_modal        : "",
            finaliza_carga      : false,
            parametros_base     : { activo: true, paginate: true },
            datosLogin          : "",
            ciudades            : [],
            estados             : [],
            estado_id           : null,
            departamento_id     : "",
            clientes            : [],
            empresas            : [],
            sucursales          : [],
            departamentos       : [],
            horarios            : [],
            cliente_value       : null,
            empresa_value       : null,
            sucursal_value      : null,
            departamento_value  : null,
            sucursal_id         : "",
            rol                 : "",
            nombre_completo     : "",
            nombre_completo_empleados: [],
            nombre_completo_correo: null,
            conteo_parametros   : 0,
            estados_civiles     : [],
            nombre_archivo      : "",
            archivo : {
                archivo     : 0,
                cliente_id  : 0,
                empresa_id  : 0,
                sucursal_id : 0,
                rol_name    : null,
            },
            empleado_ar         : null,
            imageUrl            : "",
            menu_inicio         : false,
            menu_final          : false,
            fecha_inicio        : null,
            fecha_final         : null,
            menu_inicio_c       : false,
            menu_final_c        : false,
            fecha_inicio_c      : null,
            fecha_final_c       : null,
            nombreImagen        : "",
            imagen              : "/static/modal/empleadoInactivo.svg",
            dialog_restaurar    : false,
            dataEmpleado        : null,
            fechaRestaurar      : null,
            isLoading           : false,
            tituloModal         : false,
            isSaving            : false,
        };
    },
    computed: {
        ...mapState("auth", ["datos", "user"]),
        computedSistema: function(){
            if(this.$session.get("sistema") == 'gdth'){
                return true
            }
            else{
                return false
            }
            
        }
    },
    watch: {
        cliente_value: function(val) {
            if(val != null){
                this.cambiaCliente(val);
            }
        },
        empresa_value: function(val) {
            if(val != null){
                this.cambiaEmpresa(val);
            }
        },
        sucursal_value: function(val) {
            if(val != null){
                this.cambiaSucursal(val);
            }
        },
    },
    methods: {
        ...mapActions("auth", ["notificacion"]),

        listar(parametros = null) {
            let self = this;
            this.datosLogin = this.$session.get("usuario");
            this.rol = this.datosLogin.rol.name;
            this.urlImg = GetUrlImg.getURL();

            this.filters.rol_name = this.datosLogin.rol.name;
            this.filters.usuario_id = this.datosLogin.id;

            if (this.rol == "root") {
                this.getClientes();
            }

            if (this.rol == "admin") {
                this.filters.cliente_id = this.datosLogin.cliente_id;
                this.getEmpresas();
            } 
            else if (this.rol == "admin-empresa") {
                this.empresa_value = this.filters.empresa_id = this.datosLogin.empresa_id;
            } 
            else if (this.rol == "admin-sucursal") {
                this.filters.sucursal_id = this.datosLogin.sucursal_id;
            } 
            else if (this.rol == "admin-depto") {
                this.filters.departamento_id = this.datosLogin.departamento_id;
            }
        },
        async abrirModal(item) {
            this.titulo_modal = "Histórico del empleado";
            this.imagen = "/static/modal/empleadoInactivo.svg";
            this.filters_historico.empleado_id = item.id;
            if (this.$refs.tableHistorico) {
                this.$refs.tableHistorico.getData();
            }
            this.finaliza_carga = true;

            setTimeout(function() {document.getElementById("btnModal").click();}, 100);
        },
         async cerrarModal() {
            this.resetValores();
            this.dialog = false;
            this.isSaving = false;
            this.dialog_restaurar = false;
            this.filters_historico.empleado_id = null;
            
        },
        loadModalData() {
            let cliente = null;
            let empresa = null;
            let sucursal = null;
            let depto = null;

            this.fecha_inicio   = null;
            this.fecha_final    = null;
            this.fecha_inicio_c = null;
            this.fecha_final_c  = null;
            this.cliente_value  = null;
            this.empresa_value  = null;
            this.sucursal_value = null;
            this.empleado.departamento_id = null;

            if(this.$refs.FechaInicioFilter != undefined || this.$refs.FechaInicioFilter != null){
                this.$refs.FechaInicioFilter.resetDate();
            }
            if(this.$refs.FechaFinalFilter != undefined || this.$refs.FechaFinalFilter != null){
                this.$refs.FechaFinalFilter.resetDate();
            }

            if (this.rol == "root") {
                this.getClientes();
            }
            if (this.rol == "admin") {
                this.cliente_value = this.datosLogin.cliente_id;
                this.cambiaCliente(this.datosLogin.cliente_id);
                cliente = this.datosLogin.cliente_id;
            }
            if (this.rol == "admin-empresa") {
                this.cliente_value = this.datosLogin.cliente_id;
                this.empresa_value = this.datosLogin.empresa_id;
                this.cambiaEmpresa(this.datosLogin.empresa_id);
                empresa = this.datosLogin.empresa_id;
            }
            if (this.rol == "admin-sucursal") {
                this.cliente_value = this.datosLogin.cliente_id;
                this.empresa_value = this.datosLogin.empresa_id;
                this.sucursal_value = this.datosLogin.sucursal_id;
                this.cambiaSucursal(this.datosLogin.sucursal_id);
                sucursal = this.datosLogin.sucursal_id;
            }
            if (this.rol == "admin-depto") {
                depto = this.datosLogin.departamento_id;
            }
        },
        setFilters() {
            let fecha_inicio    = this.fecha_inicio;
            let fecha_final     = this.fecha_final;
            let fecha_inicio_c  = this.fecha_inicio_c;
            let fecha_final_c   = this.fecha_final_c;
            let cliente         = this.cliente_value;
            let empresa         = this.empresa_value;
            let sucursal        = this.sucursal_value;
            let departamento    = this.empleado.departamento_id;
            let correo          = this.nombre_completo_correo;

            let filterParams        = {
                min_fecha_ingreso   : fecha_inicio,
                max_fecha_ingreso   : fecha_final,
                min_fecha_baja      : fecha_inicio_c,
                max_fecha_baja      : fecha_final_c,
                cliente_id          : cliente,
                empresa_id          : empresa,
                sucursal_id         : sucursal,
                departamento_id     : departamento,
                correo              : correo,
            };

            let defaultParams       = {
                activo              : false,
                baja                : true,
                paginate            : true,
                include_estado      : true,
                include_ciudad      : true,
                include_cliente     : true,
                include_empresa     : true,
                include_sucursal    : true,
                include_departamento: true,
                cliente_id          : this.empleado.cliente_id,
                empresa_id          : this.empleado.empresa_id,
                sucursal_id         : this.empleado.sucursal_id,
                departamento_id     : this.empleado.departamento_id,
                rol_name            : this.datosLogin.rol.name,
                usuario_id          : this.datosLogin.id,
            };

            if (filterParams != null) {
                Object.assign(defaultParams, filterParams);
            }

            this.filters = defaultParams;

            this.fecha_inicio   = null;
            this.fecha_final    = null;
            this.fecha_inicio_c = null;
            this.fecha_final_c  = null;
            this.cliente_value  = null;
            this.empresa_value  = null;
            this.sucursal_value = null;
            this.empleado.departamento_id = null;

            if(this.$refs.FechaInicioFilter != undefined || this.$refs.FechaInicioFilter != null){
                this.$refs.FechaInicioFilter.resetDate();
            }
            if(this.$refs.FechaFinalFilter != undefined || this.$refs.FechaFinalFilter != null){
                this.$refs.FechaFinalFilter.resetDate();
            }
            this.resetValores();
        },
        respuesta_error(err) {
            this.loading_guardar = false;
            if(typeof err.response.data.error === 'string'){
                Notify.ErrorToast(err.response.data.error);
            }else{
                let error = Object.values(err.response.data.error);
                let leyenda = ``;

                for (var i = 0; i < error.length; i++) {
                    leyenda+= `* ` + error[i] + `\n`;
                }

                Notify.ErrorToast(leyenda);
            }
        },
        getClientes(clientes = null) {
            let param = { activo: true, paginate: false };
            clientesApi.getClientes(param).then((response) => {
                this.clientes = response.data;
                this.finaliza_parametros();
            })
            .catch((err) => {
                this.loading_guardar = false;
                console.error(err);
                Notify.ErrorToast("Ocurrió un error al cargar los clientes.");
            });
        },
        getEmpresas() {
            let parametros = { activo: true, paginate: false };
            empresaApi.getEmpresas(parametros).then((response) => {
                this.empresas = response.data;
                this.finaliza_parametros();
            })
            .catch((err) => {
                this.loading_guardar = false;
                console.error(err);
                Notify.ErrorToast("Ocurrió un error al cargar los clientes.");
            });
        },
        cambiaCliente(cliente, accion = null) {
            let param = { activo: true, paginate: false, cliente_id: cliente };
            empresaApi.getEmpresas(param).then((response) => {
                this.empresas = response.data;
                this.finaliza_parametros();
            })
            .catch((err) => {
                this.loading_guardar = false;
                console.error(err);
                Notify.ErrorToast("Ocurrió un error al cargar las empresas.");
            });
        },
        cambiaEmpresa(empresa, accion = null) {
            let parametros = { activo: true, paginate: false, empresa_id: empresa };
            sucursalApi.getSucursales(parametros).then((response) => {
                this.sucursales = response.data;
                this.finaliza_parametros();
            })
            .catch((err) => {
                this.loading_guardar = false;
                console.error(err);
                Notify.ErrorToast("Ocurrió un error al cargar las sucursales.");
            });
        },
        cambiaSucursal(sucursal, accion = null) {
            let parametros = { activo: true, paginate: false, sucursal_id: sucursal };
            departamentoApi.getDepartamentos(parametros).then((response) => {
                this.departamentos = response.data;
                this.finaliza_parametros();
            })
            .catch((err) => {
                this.loading_guardar = false;
                console.error(err);
                Notify.ErrorToast("Ocurrió un error al cargar los departamentos.");
            });
        },
        cambiaDepartamento(departamento, accion = null) {
            let parametros = {
                activo: true,
                paginate: false,
                departamento_id: departamento,
            };
            horariosApi.getHorarios(parametros).then((response) => {
                this.horarios = response.data;
                this.finaliza_parametros();
            })
            .catch((err) => {
                this.loading_guardar = false;
                console.error(err);
                Notify.ErrorToast("Ocurrió un error al cargar los horarios.");
            });
        },
        finaliza_parametros() {
            this.finaliza_carga = false;
            this.conteo_parametros = this.conteo_parametros + 1;
            if (this.accion == "add" && this.conteo_parametros >= 3) {
                this.finaliza_carga = true;
            }
            if (this.accion == "update" && this.conteo_parametros >= 8) {
                this.finaliza_carga = true;
            }
        },
        abrirModalRestaurar(item = null){
            this.isLoading  = true;
            this.imagen = '/static/modal/empleadoUpdate.svg';

            this.tituloModal = "Restaurar empleado";
            this.dataEmpleado = item;
            this.isLoading  = false;
            setTimeout(function(){ document.getElementById("btnModalRestaurar").click(); }, 100);
        },
        restaurarEmpleado() {
            let self = this;

            this.$refs.form.validate().then(success => {
                this.isSaving = true;
                if(!success) {
                    this.isSaving = false;
                    return;
                }

                if(self.validarFecha(self.fechaRestaurar) == false){
                    Notify.ErrorToast(`Error en el formato de la fecha.`);
                    self.isSaving = false;
                    self.isLoading = false;
                    return;
                }

                let usuario_id = this.datosLogin.id;
                let param = {
                    id: this.dataEmpleado.id,
                    accion: "Reingreso",
                    usuario_id: usuario_id,
                    fecha: this.fechaRestaurar
                };

                this.isLoading = true;
                empleadosApi.reingresoEmpleado(param).then((response) => {
                    this.$refs.tableEmpleados.getData();
                    this.listar();
                    this.cerrarModal();
                    Notify.Success(
                        "Colaborador restaurado",
                        "El colaborador ha sido restaurado satisfactoriamente."
                    );
                })
                .catch((err) => {
                    this.isLoading = false;
                    this.isSaving = false;
                    if(typeof err.response.data.error === 'string'){
                            Notify.ErrorToast(err.response.data.error);
                    }else{
                        let error = Object.values(err.response.data.error);
                        let leyenda = ``;

                        for (var i = 0; i < error.length; i++) {
                            leyenda+= `* ` + error[i] + `\n`;
                        }

                        Notify.ErrorToast(leyenda);
                    }
                });
            });
        },
        respuesta_ok() {
            Swal.fire({
                position: "center",
                type: "success",
                title: "Operación exitosa",
                showConfirmButton: true,
            });
        },
        resetValores() {
            this.clientes           = [];
            this.empresas           = [];
            this.sucursales         = [];
            this.departamentos      = [];
            this.cliente_value      = null;
            this.empresa_value      = null;
            this.sucursal_value     = null;
            this.empleado.departamento_id= null;

            

            this.$nextTick(() => { 
                if(this.$refs.form != undefined || this.$refs.form != null){
                    this.$refs.form.reset();
                }
                if(this.$refs.FechaRestaurar != undefined || this.$refs.FechaRestaurar != null){
                    this.$refs.FechaRestaurar.resetDate();
                }
                this.fechaRestaurar = null;
            });


        },
        init() {
            const elementScroll = document.querySelector("#scroll");
            if (elementScroll) {
                const ps = new PerfectScrollbar(elementScroll, {
                wheelSpeed: 2,
                wheelPropagation: true,
                minScrollbarLength: 20,
                suppressScrollY: true,
                });
            }
            $(".ps__thumb-x").css("position", "fixed");
        },
        eliminar(id, empleado, email) {
            Notify.Alert(
                "ADVERTENCIA",
                "¿Estás seguro que deseas eliminar el colaborador?",
                "Eliminar",
                () => {
                    let idEmpleado  = id;
                    let accion      = "Eliminar";
                    let usuario_id  = this.datosLogin.id;
                    let param       = {
                        rol_name    : this.datosLogin.rol.name,
                        id          : idEmpleado,
                        accion      : accion,
                        usuario_id  : usuario_id,
                        email       : email,
                    };
                    empleadosApi.eliminarEmpleado(param).then((response) => {
                        this.$refs.tableEmpleados.getData();
                        this.listar();
                        Notify.Success("Colaborador eliminado", "El colaborador ha sido eliminado satisfactoriamente.");
                    })
                    .catch((err) => {
                        if(typeof err.response.data.error === 'string'){
                            Notify.ErrorToast(err.response.data.error);
                        }else{
                            let error = Object.values(err.response.data.error);
                            let leyenda = ``;

                            for (var i = 0; i < error.length; i++) {
                                leyenda+= `* ` + error[i] + `\n`;
                            }

                            Notify.ErrorToast(leyenda);
                        }
                    });
                }
            );
        },
        detalleEmpleado(data) {
            this.$session.remove("detalleEmpleado");
            this.$session.set("detalleEmpleado", data);
            this.$router.push("/empleado/detalleEmpleado");
        },
        dateFormat(fecha) {
            let fecha2 = fecha.split("-");
            return fecha2[2] + " / " + fecha2[1]+ " / " + fecha2[0];
        },

        /**
         * @method validarFecha Este método valida una fecha
         * @description Valida la fecha que se pase y devuelve true en caso de que la fecha sea verdadero y falso en caso de que la fecha sea incorrecta
         * @param {string} valorFecha formato AAAA-MM-DD
         * @return {boolean} devuelve un true o false.
        */
        validarFecha(valorFecha) {
            try{
                let fecha = valorFecha.split("-");        
                let dia = fecha[2];        
                let mes = fecha[1];        
                let ano = fecha[0];        
                let estado = true;  
                let dmax = 0;
                let diaC = null;
                let mesC =  null;
                let anoC = null;
                
                if ((dia.length == 2) && (mes.length == 2) && (ano.length == 4)) {        
                    switch (parseInt(mes)) {        
                        case 1:dmax = 31;break;        
                        case 2: 
                            if (((ano % 4 == 0) && (ano % 100 != 0 )) || (ano % 400 == 0))
                                dmax = 29; 
                            else 
                                dmax = 28;        
                            break;        
                        case 3:dmax = 31;break;        
                        case 4:dmax = 30;break;        
                        case 5:dmax = 31;break;        
                        case 6:dmax = 30;break;        
                        case 7:dmax = 31;break;        
                        case 8:dmax = 31;break;        
                        case 9:dmax = 30;break;        
                        case 10:dmax = 31;break;       
                        case 11:dmax = 30;break;      
                        case 12:dmax = 31;break;       
                    }  
                    
                    dmax!=""?dmax:dmax=-1;
                    
                    if ((dia >= 1) && (dia <= dmax) && (mes >= 1) && (mes <= 12)) {
                        let i=0;
                        for (i=0 ; i<fecha[2].length; i++) {      
                            diaC = fecha[2].charAt(i).charCodeAt(0);        
                            (!((diaC > 47) && (diaC < 58)))?estado = false:'';       
                            mesC = fecha[1].charAt(i).charCodeAt(0);        
                            (!((mesC > 47) && (mesC < 58)))?estado = false:'';       
                        }  
                    } 
                    else{
                        estado = false;
                    }
                    
                    let j = 0;
                    for(j=0; j < fecha[0].length; j++) {
                        anoC = fecha[0].charAt(j).charCodeAt(0);  
                        (!((anoC > 47) && (anoC < 58)))?estado = false:'';        
                    }
                } 
                else {
                    estado = false;
                }        
                return estado; 
            }catch(err){
                return false;
            }  
        },
        redireccionar(){
            this.$router.push('/dashboard');
        }
    },

    mounted() {
        this.init();
        document.querySelector('#tableScroll thead tr th:nth-child(1)').style.paddingRight   = "4px";
        document.querySelector('#tableScroll thead tr th:nth-child(1)').style.width   = "150px";
    },
    created() {
        this.listar();
    },
    updated() {    
        let  tablaHistorico = document.querySelector('#tablaHistorico');    
        document.querySelector('#tableScroll thead tr th:nth-child(1)').style.paddingRight   = "4px";
        document.querySelector('#tableScroll thead tr th:nth-child(1)').style.width   = "150px";
        if(tablaHistorico){
            document.querySelector('#tablaHistorico thead tr th:nth-child(1)').style.paddingRight   = "4px"
            document.querySelector('#tablaHistorico thead tr th:nth-child(2)').style.paddingRight   = "4px"
            document.querySelector('#tablaHistorico thead tr th:nth-child(2)').style.paddingLeft    = "4px"
            document.querySelector('#tablaHistorico thead tr th:nth-child(3)').style.paddingRight   = "4px"
            document.querySelector('#tablaHistorico thead tr th:nth-child(3)').style.paddingLeft    = "4px"
            document.querySelector('#tablaHistorico thead tr th:nth-child(4)').style.paddingRight   = "4px"
            document.querySelector('#tablaHistorico thead tr th:nth-child(4)').style.paddingLeft    = "4px"

            document.querySelector('#tablaHistorico thead tr th:nth-child(1) div').style.textAlign  = "initial"
            document.querySelector('#tablaHistorico thead tr th:nth-child(3)').style.width          = "150px"
        }
    }
};
</script>

<style scoped>
    .RangoIngreso {
        font-family: Montserrat !important;
        font-style: normal !important;
        font-weight: 500 !important;
        font-size: 14px !important;
        line-height: 17px !important;
        color: #1E2245 !important;
    }
    #tablaHistorico tbody{
        display:block;
        max-height:60vh;
        min-width: 940px;
        background-color: #fdfcfc;
    }
    #btnModalRestaurar {
        display: none;
    }
</style>
